
<h2 *appApplyIfNotEmpty="translationService.getTranslation('login_box_header')"
    [innerHTML]="translationService.getTranslation('login_box_header')"></h2>

@if (loading || redirecting) {
  <div style="text-align: center; margin:5px">
    <app-loading-spinner/>
  </div>
}

@if (useHassoForm && hassoLoginUrl) {
  <iframe title="" [src]="hassoLoginUrl" [style.height]="ssoFormPropagatedHeight"></iframe>
  @if (!loading) {
    <div class="btn-back">
      <button mat-raised-button color="primary" (click)="onBack()" [innerHTML]="translationService.getTranslation('button_back')"></button>
    </div>
  }
}

@if (!useHassoForm) {
  <div class="mat-typography" [formGroup]="loginForm" (keyup.enter)="onLogin()">
    @if (!loading) {
      <div class="row">
        @if (error) {
          <div class="col-12 alert alert-danger" [innerHTML]="translationService.getTranslation(error)">
          </div>
        }
        <div class="col-12">
          <mat-form-field>
            <mat-label [innerHTML]="translationService.getTranslation('login_email')"></mat-label>
            <input matInput formControlName="email" type="text" required email name="username" autocomplete="off">
            <mat-error>{{loginForm.get('email').getError('message')}}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field>
            <mat-label [innerHTML]="translationService.getTranslation('login_password')"></mat-label>
            <input matInput formControlName="password" type="password" required name="password">
            <mat-error>{{loginForm.get('password').getError('message')}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    }
  </div>
  <div>
    <button class="me-3" mat-raised-button color="primary" [disabled]="loading" (click)="onLogin()" [innerHTML]="translationService.getTranslation('login_login')"></button>
    <button mat-raised-button color="primary" [innerHTML]="translationService.getTranslation('login_close')"></button>
  </div>
}
